export default "<p>product-detail works!</p>\n"